import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import ConfigurationService from '../../apiclients/ConfigurationService';
import Loader from './Loader';
import StoreController from '@projeccions-pdc/frontend-storage';
import Fab from '@material-ui/core/Fab';
import AppContext from '../../AppContext';
import CachedImage from './CachedImage';
import AppController from '../../AppController';
import AuthController from '../Auth/AuthController';

const styles = (theme) => ({
    platformButtonContainer: {
        display: 'inline-block',
        textAlign: 'center',
        margin: '10px',
        fontSize: '12px',
    },
    button: {
        borderRadius: '20%',
        height: '90px',
        width: '90px',
    },
    platformName: {
        marginTop: '10px',
        width: '100px',
        height: '20px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        fontSize: '14px',
    },
});

class PlatformChanger extends Component {
    constructor(props) {
        super(props);
        this.state = {
            platforms: [],
            loading: true,
        };
        // this.refs = [];
    }

    compareArrays = (arrA, arrB) => {
        for (let i = 0; i < arrA.length; i++) {
            if (arrA[i] !== arrB[i]) {
                return false;
            }
        }
        return true;
    };

    async componentDidMount() {
        this.refreshData();
        // await this.refreshOnline();
    }

    componentDidUpdate(prevProps) {
        // if (this.compareArrays(this.props.myPlatforms.platforms, prevProps.myPlatforms.platforms) !== true) {
        //     this.refreshData();
        // }
    }

    // refreshOnline = async () => {
    //     let isOnline = await isDeviceOnline();
    //     this.setState({ isOnline });
    // }

    refreshData = async () => {
        let appContext = new AppContext();
        let myPlatforms = appContext.getMyPlatforms();
        let platforms = myPlatforms.platforms;
        let newPlatforms = [];
        for (let i = 0; i < platforms.length; i++) {
            let currPlatformId = platforms[i];
            let title = 'Name Unknown';
            let storeController = new StoreController(currPlatformId, '');
            try {
                let platformConfig = await ConfigurationService.getPlatformConfiguration(currPlatformId);
                title = platformConfig.title;
                storeController.set('platformConfig', platformConfig);
            } catch (err) {
                console.log(err);
                let platformConfig = storeController.get('platformConfig');
                if (platformConfig !== undefined) {
                    title = platformConfig.title;
                }
            }
            // console.log('platformName', title);
            newPlatforms.push({
                platformId: currPlatformId,
                title,
            });
        }
        this.setState({ platforms: newPlatforms, loading: false });
    };

    onPlatformIdChange = async (platformId, evt) => {
        await AuthController.refreshAuthenticatedUser();
        await AuthController.refreshSession();
        let appContext = new AppContext();
        appContext.setPlatformId(platformId, evt);
        await AppController.refreshPlatformConfig(this.state.config, this.state.platformId);
        if (this.props.onPlatformIdChanged) {
            this.props.onPlatformIdChanged();
        }
    };

    // cacheLogo = (platform, idx) => {
    //     if (this.state.isOnline === true) {
    //         try {
    //             let platformId = platform.platformId;
    //             let storeController = new StoreController(platformId, '');
    //             let base = getBase64Image(this.refs['ref' + idx]);
    //             storeController.set('logo', base);
    //         } catch (err) {
    //             console.err('caching logo in PlatformChanger', err);
    //         }
    //     }
    // }

    render() {
        return (
            <div style={{ textAlign: 'center' }}>
                {this.state.loading === true ? (
                    <Loader loading={true} />
                ) : this.state.platforms ? (
                    this.state.platforms.map((platform, i) => {
                        let platformId = platform.platformId;
                        return (
                            <div key={platformId} className={this.props.classes.platformButtonContainer}>
                                <Fab
                                    onClick={(evt) => {
                                        evt.stopPropagation();
                                        evt.preventDefault();
                                        this.onPlatformIdChange(platformId, evt);
                                    }}
                                    classes={{ root: this.props.classes.button }}
                                >
                                    <CachedImage
                                        imageKey="logo"
                                        platformId={platform.platformId}
                                        fileName={'logo.png'}
                                        noCache={true}
                                        renderElement={(src) => <img src={src} width="85%" height="85%" alt={''} />}
                                    />
                                </Fab>
                                <div className={this.props.classes.platformName}>{platform.title}</div>
                            </div>
                        );
                    })
                ) : (
                    'No platforms available'
                )}
            </div>
        );
    }
}

PlatformChanger.propTypes = {
    classes: PropTypes.object.isRequired,
    onPlatformIdChanged: PropTypes.func,
};

export default withStyles(styles)(withRouter(PlatformChanger));
